document.addEventListener('DOMContentLoaded', function () {
  // 创建 IntersectionObserver 实例
window.YGImageLoader = new IntersectionObserver(
  (entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const img = entry.target;
        const newImg = new Image();
        newImg.onload = () => {
          img.src = newImg.src;
          img.removeAttribute("data-src"); // 如果只需要加载一次
          img.removeAttribute("srcset");
          observer.unobserve(img); // 停止观察该元素
        };
        newImg.src = img.getAttribute("data-src");
      }
    });
  },
  {
    rootMargin: "50px", // 预加载距离视口 50px 的图片
  }
);

class YGImage extends HTMLElement {
  constructor() {
    super();
    this.init();
  }
  init() {
    // 这里放置初始化逻辑
    this.loaderImg();
  }

  get images() {
    return this.querySelectorAll("img[data-src]");
  }

  loaderImg() {
    // 这里放置自定义逻辑
    this.images.forEach((img) => {
      window.YGImageLoader.observe(img);
    });
  }
}
if (!window.customElements.get("yg-image")) {
  window.customElements.define("yg-image", YGImage);
}
  class YGSwiper extends HTMLElement {
    constructor() {
        super()
    }
    connectedCallback() {
      this.getAllAttributes()
      this.initSwiper()
    }

    getAllAttributes() {
      let booleanAttrs = ['loop', 'pagination', 'navigation'];
      let jsonAttrs = ['breakpoints']
      for (const attr of this.attributes) {
        if (attr.name.startsWith('data-')) {
          const cleanName = attr.name.slice(5); // 去除 'data-' 前缀
          
          let value = attr.value;
          if (booleanAttrs.includes(cleanName)) {
            value = value === 'true';
          } else if (jsonAttrs.includes(cleanName)) {
            value = this.parseSwiperBreakpoints(value);
          }

          this[cleanName] = value;
        }
      }
    }

    parseSwiperBreakpoints(str) {
      const result = {};
      const pairs = str.split(',');
    
      console.log("pairs",pairs)
      for (const pair of pairs) {
        const [breakpoint, values] = pair.split(':');
        if (!breakpoint || !values) continue;
    
        const [slides, space] = values.split('-').map(Number);
    
        result[breakpoint.trim()] = {
          slidesPerView: slides,
          spaceBetween: space
        };
      }

      console.log("result",   result)
      return result;
    }

    initSwiper() {
      const swiper = new Swiper(this, {
        // 这里放置 swiper 的配置
        loop: this['loop'],
        autoplay: this['autoplay']?{
          delay: this['autoplay'],
          stopOnLastSlide: false,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        }:false,
        pagination: this['pagination']?{
          el: '.swiper-pagination',
          clickable: true,
        }:false,
        navigation: this['navigation']?{
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        }:false,
        breakpoints: this['breakpoints']?this['breakpoints']:false
      })
    }
  }
  if (!window.customElements.get('yg-swiper')) {
      window.customElements.define('yg-swiper', YGSwiper)
  }

  class YGPassword extends HTMLElement {
      constructor() {
          super()
      }

      get password() {
          return this.querySelector('input');
      }

      get showIcon() {
          return this.querySelector('.yg-password-show');
      }

      get hideIcon() {
          return this.querySelector('.yg-password-hide');
      }

      connectedCallback() {
        this.showIcon.addEventListener('click', () => {
          this.password.type = 'text';
          this.showIcon.style.display = 'none';
          this.hideIcon.style.display = 'block';
        });

        this.hideIcon.addEventListener('click', () => {
          this.password.type = 'password';
          this.showIcon.style.display = 'block';
          this.hideIcon.style.display = 'none';
        })
      }
  }
  if (!window.customElements.get('yg-password')) {
      window.customElements.define('yg-password', YGPassword)
  }

  class YGPopupBox extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('click', (e) => {
        this.closePopup(e, () => {});
      });
    }

    openPopup($popupTemplate, fn) {
      // popupTemplate：需要替换的元素
      this.querySelector('.yg-popup-box-content-inner').innerHTML = $popupTemplate.innerHTML;
      document.querySelector('body').style.overflow = 'hidden';
      this.style.display = 'flex';
      fn();
    }
    closePopup(e, fn) {
      if (e.target.className == 'yg-popup-box-close' || e.target.className == 'yg-popup-box') {
        this.style.display = 'none';
        this.querySelector('.yg-popup-box-content-inner').innerHTML = '';
        document.querySelector('body').style.overflow = 'auto';
        fn();
      }
    }
  }
  if (!window.customElements.get('yg-popup-box')) {
    window.customElements.define('yg-popup-box', YGPopupBox);
  }

  class YGOpenPopup extends HTMLElement {
    constructor() {
      super();
      this.init();
      this.$popupBox = document.querySelector('yg-popup-box.yg-popup-box');
    }
    init() {
      // 这里放置初始化逻辑
      this.addEventListener('click', this.itemClick.bind(this));
    }
    itemClick() {
      // 这里放置自定义逻辑
      let $popupTemplate = this.querySelector('template') || this.querySelector('.yg-popup-template');

      $popupTemplate && this.$popupBox.openPopup($popupTemplate, () => {});
      
    }
  }
  if (!window.customElements.get('yg-open-popup')) {
    window.customElements.define('yg-open-popup', YGOpenPopup);
  }
})